import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import CrossSvg from '@shared/svg/cross.svg'
import styled, { CSSObject } from 'styled-components'

interface ViewProps {
	img: string
	link: string
}

export const BlockCustomPartnerLogos = ({ link, img }: ViewProps) => (
	<Section>
		<ViewRoot>
			<Text>Совместный проект</Text>
			<ViewRowInner>
				<Logo>
					<a href="/" target="_blank" rel='noopener noreferrer nofollow'>
						<StyledLogo name="cc-logo.png" alt="cc-logo" />
					</a>
				</Logo>
				<CrossSvg />
				<Logo>
					<a href={link} target="_blank" rel='noopener noreferrer nofollow'>
						<StyledImage src={img} alt={img} />
					</a>
				</Logo>
			</ViewRowInner>
		</ViewRoot>
	</Section>
)

const ViewRoot = styled.div(
	({ theme }) =>
		({
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			marginBottom: 120,
			gap: '20px 32px',
			flexDirection: 'column',

			[theme.mediaQueries.mediaMinWidthMobile]: {
				flexDirection: 'row',
			},
		} as CSSObject)
)

const ViewRowInner = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
})

const Text = styled.div(({ theme }) => ({
	...theme.typography.header18_24,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header24_32,
	},
}))

const Logo = styled.div(() => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: 196,
	height: 63,
	padding: '16px 26px',
	boxShadow:
		'0px 18px 65px rgba(0, 0, 0, 0.07), 0px 4.02054px 6.37957px rgba(0, 0, 0, 0.0287811), 0px 1.19702px 0px rgba(0, 0, 0, 0.0082118)',
	borderRadius: 8,
	a: {
		height: '100%',
	},
}))

const StyledLogo = styled(Image)(() => ({
	width: 'auto',
	height: 34,
}))

const StyledImage = styled.img(() => ({
	width: 'auto',
	height: 34,
}))
